import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export function BrandHome({ size = "md", className = "" }) {
  const text = size === "lg" ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl";
  const img = size === "lg" ? "w-10 h-10" : "w-9 h-9";
  return (
    <Link
      to="/"
      title="الرئيسية · Home"
      data-testid="brand-home-btn"
      className={`group inline-flex items-center gap-2 rounded-2xl border border-primary/30 bg-primary/10 hover:bg-primary/20 hover:border-primary/60 active:scale-[0.98] ps-1.5 pe-3 py-1 transition-all ${className}`}
    >
      <img src="/rawaj-logo.png?v=2" alt="رواج الذكية" className={`${img} object-cover rounded-lg ring-1 ring-primary/30`} />
      <span className={`${text} font-extrabold font-heading gradient-text notranslate leading-none`} translate="no">رواج الذكية</span>
      <Home className="w-4 h-4 text-primary/70 group-hover:text-primary transition-colors" />
    </Link>
  );
}
